/**
 * https://cloudscape.design/foundation/visual-foundation/colors/
 */

export const RED_600 = '#d91515';
export const GREY_400 = '#9ba7b6';
export const GREY_550 = '#5f6b7a';
